const TRANSFER_BUTTON =
  ' <button type="button" class="wo-transfer-btn" style="font-size:0.68em;padding:0 5px;margin-left:6px;line-height:1.1;border:1px solid #a080a8;border-radius:3px;background:none;color:#a080a8;cursor:pointer;vertical-align:middle">transfer</button>';

function workOrderTransferButtonHtml(request) {
  if (!request || !request.nameIsStaff) return '';
  return TRANSFER_BUTTON;
}

function isTransferButtonTarget(event) {
  const el = event && event.target;
  if (!el || typeof el.closest !== 'function') return false;
  return Boolean(el.closest('.wo-transfer-btn'));
}

module.exports = {
  workOrderTransferButtonHtml,
  isTransferButtonTarget,
};
